import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { Animations } from '@styles/animation/animations';

@Component({
  selector: 'recrewt-sticky-bottom-action-bar',
  imports: [MatIconModule, MatButtonModule, MatCardModule, MatTooltipModule, TranslateModule],
  templateUrl: './sticky-bottom-action-bar.component.html',
  styleUrl: './sticky-bottom-action-bar.component.scss',
  animations: [Animations.slideInBottom],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.collapsed]': 'collapsed()' },
})
export class StickyBottomActionBarComponent {
  readonly icon = input.required<string>();
  readonly headline = input.required<string>();
  readonly text = input.required<string>();

  readonly collapsed = signal(false);

  toggleCollapsed(): void {
    this.collapsed.update((collapsed) => !collapsed);
  }

  expand(): void {
    this.collapsed.set(false);
  }
}
